// extracted by mini-css-extract-plugin
export var dropdownIcon = "_rn-6";
export var imgContainer = "_rn-3";
export var menuIcon = "_rn-5";
export var pillWrapper = "_rn-2";
export var pillsContainer = "_rn-1";
export var subscriptionCard = "_rn-0";
export var subscriptionLogo = "_rn-4";